import { CartActions } from '../actions';
import { CustomCartState } from '../cart-state';

export const initialState: CustomCartState['tempCartId'] = undefined;

export function reducer(
  state = initialState,
  action: CartActions.SafelySetActiveCartId | CartActions.ClearTemporaryCartId,
): CustomCartState['tempCartId'] {
  switch (action.type) {
    case CartActions.SAFELY_SET_ACTIVE_CART_ID: {
      return action.payload;
    }

    case CartActions.CLEAR_TEMPORARY_ACTIVE_CART_ID: {
      return initialState;
    }

    default: {
      return state;
    }
  }
}
